import { render } from "./SizeSelector.vue?vue&type=template&id=57c1a9c9&scoped=true"
import script from "./SizeSelector.vue?vue&type=script&lang=js"
export * from "./SizeSelector.vue?vue&type=script&lang=js"

import "./SizeSelector.vue?vue&type=style&index=0&id=57c1a9c9&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c1a9c9"]])

export default __exports__